import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ProjectList from '../../components/Attendance/userMonthlyReport'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { v3_userMonthlyAttendance } from '../../actions/v3/attendance'
import moment from 'moment'
const List = (props) => {

    const location = useLocation();
    const { project, userId, month, year } = location.state || {};
    const [data, setData] = useState([])

    const [selectedMonth, setMonth] = useState(moment().format('YYYY-MM'))
    useEffect(() => {
        v3_userMonthlyAttendance(project.PROJECT_ID, moment(selectedMonth).format('MM'), moment(selectedMonth).format('YYYY'), userId).then((res) => {
            if (res.status) {
                setData(res.result.rows);
                props.history.push(constant.Authedcomponent.attendanceMonthlyReportUser.url, {
                    project, userId, month, year
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [selectedMonth])

    return (
        <Layout
            title={`Monthly Attendance | ${project.PROJECT_NAME}`}
        >

            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Attendance Sheet</h4>
                <input
                    type="month"
                    className="form-control"
                    style={{ width: "200px" }}
                    value={selectedMonth}
                    onChange={(e) => { setMonth(e.target.value) }}
                />
            </div>
            {data && <ProjectList
                rows={data}
                project={project}
                month={moment(month).format('MM')}
                year={moment(month).format('YYYY')}
            />}
        </Layout>
    )
}

export default List